<template>
  <div class="row min-h-screen shadow-none">
    <div class="col-lg-12">
      <div :class="[, 'be-loading', { 'be-loading-active': isBusy }]">
        <ProductsHeader :activeTab="activeTab" @openCreateModal="openCreateModal"
          @openConfirmDownload="openConfirmDownload" @tabSwitched="switchTab" @viewFilter="viewFilter"
          :hasPermission="hasPermission" :downloadFile="downloadFile" :dowloading="dowloading"
          :Product_fields="Product_fields" :formattedProductFields="formattedProductFields" />
      </div>
      <div v-if="activeTab === 'product'">
        <ProductsTable :products="Products" :pageSize="pageSize" :pageCount="pageCount" @viewEdit="viewEdit" :refreshList="refreshProduct"
          :page="page" :count="count" :user="user" :hasPermission="hasPermission" @gotoPage="gotoPage"
          @changeLimit="changeLimit" :loading="loading" />
      </div>
      <div v-if="activeTab === 'category'">
        <ProductCategories />
      </div>
      <div v-if="activeTab === 'units'">
        <ProductUnits />
      </div>
    </div>

    <div class="modal fade colored-header colored-header-primary" id="mod-edit" role="dialog">
      <div class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end">
        <div class="modal-content rounded-none bg-[#f8f8f8] p-[20px] md:p-[40px] min-h-screen">
          <div class="modal-header modal-header-colored flex items-start justify-between p-0 m-0">
            <h4 class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]">
              Edit product
            </h4>
            <button class="text-2xl text-[#353535]" type="button" data-dismiss="modal" aria-hidden="true"
              @click="previewUrl = ''">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="flex flex-col items-center w-full">
              <div>
                <div class="flex flex-col items-center">
                  <div>
                    <img v-if="previewUrl" class="image-preview" :src="previewUrl" alt="logo" width="80" height="80" />
                  </div>

                  <input id="file" type="file" class="custom-file-input" @change="uploadFile" ref="file" hidden />
                  <button v-if="previewUrl"
                    class="p-[8px] border-[1.5px] border-[#DC2828] border-solid text-[#DC2828] text-[14px] leading-[20px] rounded-[8px] mt-[6px] mb-[16px]"
                    @click="cancelUpload">
                    Delete image
                  </button>
                  <button v-else
                    class="btn btn-custom btn-outline-primary btn-md mb-[16px] mt-[6px] text-[14px] leading-[20px] p-[8px]"
                    @click="onPickFile">
                    Upload Image
                  </button>
                </div>
              </div>
            </div>
            <div>
              <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">Category</label>
              <div>
                <select
                  class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                  placeholder="Select an option" v-model="updateProduct.categoryId">
                  <option v-for="cat in filteredCategory" :key="cat.id" :value="cat.id">
                    {{ cat.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="my-[16px]">
              <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">Code</label>
              <div class="">
                <input :class="[{ 'is-invalid': v2.code }]" type="text"
                  class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                  v-model="updateProduct.code" readonly />
              </div>
            </div>
            <div class="">
              <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">Name</label>
              <div class="mb-[16px]">
                <input :class="[{ 'is-invalid': v2.name }]"
                  class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                  type="text" readonly v-model="updateProduct.name" />
              </div>
            </div>
            <div class="mb-[16px]">
              <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">Description</label>
              <div>
                <textarea
                  class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                  v-model="updateProduct.description"></textarea>
              </div>
            </div>
            <div class="mb-[16px]">
              <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">Unit</label>
              <div class="">
                <input :class="[{ 'is-invalid': v2.name }]"
                  class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full outline-none focus:outline-none"
                  type="text" readonly v-model="updateProduct.unit" />
              </div>
            </div>
            <div class="mb-[16px]">
              <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">Minimum Order Quantity</label>
              <div>
                <input :class="[{ 'is-invalid': v2.minimumOrderQuantity }]" type="number"
                  class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
                  v-model="updateProduct.minimumOrderQuantity" />
                <ul v-if="v2.minimumOrderQuantity" class="parsley-errors-list filled">
                  <li class="parsley-required">Enter a valid number.</li>
                </ul>
              </div>
            </div>
            <div>
              <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">incremental Quantity</label>
              <div>
                <input :class="[{ 'is-invalid': v2.incrementalQuantity }]" type="number"
                  class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
                  v-model="updateProduct.incrementalQuantity" />
                <ul v-if="v2.incrementalQuantity" class="parsley-errors-list filled">
                  <li class="parsley-required">Enter a valid number.</li>
                </ul>
              </div>
            </div>
            <div class="mb-[16px] hidden">
              <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">Default Retail Price (RRP)</label>
              <div>
                <input :class="[{ 'is-invalid': v2.retailPrice }]" type="number"
                  class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
                  v-model="updateProduct.retailPrice" />
                <ul v-if="v2.retailPrice" class="parsley-errors-list filled">
                  <li class="parsley-required">Enter a valid number.</li>
                </ul>
              </div>
            </div>
            <div class="mb-[16px] hidden">
              <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">Default Distributor Price
                (DP)</label>
              <div class="">
                <input :class="[{ 'is-invalid': v2.distributorPrice }]" type="number"
                  v-model="updateProduct.distributorPrice"
                  class="bg-[#fff] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full" />
                <ul v-if="v2.distributorPrice" class="parsley-errors-list filled">
                  <li class="parsley-required">Enter a valid number.</li>
                </ul>
              </div>
            </div>
            <div class="flex items-center gap-[10px] max-w-max my-[16px]"
              @click="updateProduct.active = !updateProduct.active">
              <button type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer focus:outline-none"
                role="switch" :aria-checked="updateProduct.active" :class="{
                  'bg-green-800': updateProduct.active,
                  'bg-[#E4E4E7]': !updateProduct.active,
                }">
                <span aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5 bg-white': updateProduct.active,
                    'translate-x-0 bg-gray-400': !updateProduct.active,
                  }"></span>
              </button>
              <span class="cursor-pointer">
                <span class="text-[#353535] text-[16px] font-normal leading-[20px]">
                  This Product is active
                </span>
              </span>
            </div>

            <div class="flex items-center gap-[10px] max-w-max my-[24px] hidden"
              @click="updateProduct.availability = !updateProduct.availability">
              <button type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer focus:outline-none"
                role="switch" :aria-checked="updateProduct.availability" :class="{
                  'bg-green-800': updateProduct.availability,
                  'bg-[#E4E4E7]': !updateProduct.availability,
                }">
                <span aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5 bg-white': updateProduct.availability,
                    'translate-x-0 bg-gray-400': !updateProduct.availability,
                  }"></span>
              </button>
              <span class="cursor-pointer">
                <span class="text-[#353535] text-[16px] font-normal leading-[20px]">
                  This product is available for sale
                </span>
              </span>
            </div>

            <div class="flex items-center gap-[10px] max-w-max mb-[16px]" @click="
              updateProduct.allowPriceOverride =
              !updateProduct.allowPriceOverride
              ">
              <button type="button"
                class="relative inline-flex items-center flex-shrink-0 h-[24px] px-[3px] w-[46px] transition-all duration-200 ease-in-out border-[0.5px] border-[#E4E4E7] shadow-sm rounded-[10px] cursor-pointer focus:outline-none"
                role="switch" :aria-checked="updateProduct.allowPriceOverride" :class="{
                  'bg-green-800': updateProduct.allowPriceOverride,
                  'bg-[#E4E4E7]': !updateProduct.allowPriceOverride,
                }">
                <span aria-hidden="true"
                  class="inline-block w-[21px] h-[16px] bg-white transition duration-200 ease-in-out transform rounded-full pointer-events-none"
                  :class="{
                    'translate-x-5 bg-white': updateProduct.allowPriceOverride,
                    'translate-x-0 bg-gray-400':
                      !updateProduct.allowPriceOverride,
                  }"></span>
              </button>
              <span class="cursor-pointer">
                <span class="text-[#353535] text-[16px] font-normal leading-[20px]">
                  Price can be overridden by distributor
                </span>
              </span>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-normal text-[14px] border-solid px-[24px] py-[12px] w-full"
              type="button" data-dismiss="modal" @click="previewUrl = ''">
              Cancel
            </button>
            <button :disabled="isBusyModal"
              class="border-[1px] bg-[#2463eb] rounded-[8px] text-white font-normal text-[14px] border-solid px-[24px] py-[12px] w-full"
              type="button" @click.prevent="update">
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- filter modal -->
    <div class="modal fade colored-header colored-header-primary" id="mod-filter" role="dialog">
      <div class="modal-dialog m-0 p-0 absolute top-0 right-0 flex justify-end items-end">
        <div class="modal-content rounded-none bg-[#f8f8f8] p-[20px] md:p-[40px] h-[100dvh]">
          <div class="modal-header modal-header-colored flex items-start justify-between p-0 m-0">
            <h4 class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]">
              Filter
            </h4>
            <button class="text-2xl text-[#353535]" type="button" data-dismiss="modal" aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body p-0 m-0">
            <div class="pb-[16px]">
              <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">Status</label>
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full custom-select-lg"
                  placeholder="Select an option" v-model="filter.status">
                  <option value="0">All Products</option>
                  <option value="True">Active</option>
                  <option value="False">Disabled</option>
                </select>
              </div>
            </div>
            <div class="pb-[16px]">
              <label cclass="text=[#353535] font-bold-500 text-[14px] leading-[20px]">Category</label>
              <div>
                <select
                  class="bg-transparent border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full custom-select-lg"
                  placeholder="Select an option" v-model="filter.categoryId">
                  <option value="0">All Categories</option>
                  <option v-for="cat in categories" :key="cat.id" :value="cat.id">
                    {{ cat.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="pb-[16px]">
              <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">Other filters</label>
              <div>
                <input class="bg-transparent border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
                  type="text" placeholder="Filter by code or name..." v-model="filter.qry" />
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] w-full">
            <button
              class="bg-transparent border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button" data-dismiss="modal">
              Cancel
            </button>
            <button
              class="bg-transparent border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full"
              type="button" @click="reset">
              Reset
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full"
              type="button" @click="getProducts">
              <span v-if="isBusy">Loading...</span>
              <span v-else>Search</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- download modal -->
    <div class="modal fade colored-header colored-header-primary" id="mod-download" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4 class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]">
              Export Data
            </h4>
            <button class="text-2xl text-[#353535]" type="button" data-dismiss="modal" aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body p-0 m-0">
            <p class="text-[#353535] text-[16px] font-normal leading-[20px]">
              Are you sure you want to export data?
            </p>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none"
              data-dismiss="modal" aria-hidden="true">
              Cancel
            </button>
            <JsonExcel v-if="hasPermission('Product_Export')"
              class="bg-[#2463eb] border-[#2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full text-center cursor-pointer"
              :fields="Product_fields" name="product.csv" :fetch="downloadFile" type="csv">
              <button
                class="text-white text-[16px] font-medium leading-[20px] outline-none focus:outline-none w-full text-center ">
                Proceed
              </button>
            </JsonExcel>
          </div>
        </div>
      </div>
    </div>

    <Modal @proceed="finishDownload($event)" :isBusy="modal.isLoading" :text="modal.actionText"
      :message="modal.message" />
    <AddProducts :canAddProduct="canAddProduct" :SearchProduct="SearchProduct" :isSearching="isSearching"
      :addedProducts="addedProducts" :ShowConfirmAddModal="ShowConfirmAddModal" :currItem="currItem" :results="results"
      :allProducts="allProducts" :addProducts="addProducts" :Products="Products" :mappedResults="mappedResults"
      :errorMessage="errorMessage" :resetErrMsg="resetErrMsg" :isBusy="isBusy" @update-category="updateProductCategory"
      @refreshProduct="refreshProduct" :categories="categories" :closeCreateModal="closeCreateModal" />
    <div class="modal fade py-1 colored-header colored-header-primary" id="mod-confirm" role="dialog">
      <div class="modal-dialog max-w-[500px] w-full relative">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <button class="absolute right-6 top-4 text-2xl" type="button" data-dismiss="modal" aria-hidden="true">
            <span class="mdi mdi-close"></span>
          </button>
          <div class="text-center">
            <div class="flex justify-center items-center mt-[16px]">
              <img src="/assets/img/alarm.png" alt="" />
            </div>

            <p class="text-[16px] font-bold text-[#353535] mb-[5px]">
              Confirmation
            </p>
            <p class="text-[13px] font-normal text-[#96a0b5]">
              Are you sure you want to add product(s) to list?
            </p>
            <div class="mt-[15px] flex gap-2 items-center justify-center w-full">
              <button type="button" data-dismiss="modal" aria-hidden="true"
                class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full">
                Close
              </button>
              <button @click="AddProductToList" type="button"
                class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full">
                Yes, Procced
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import moment from "moment";
import { helper } from "@/helper";
import Select2 from "@/components/Select2";
import SystemPermissions from "@/permissions";
import Modal from "@/components/helpers/modal.vue";
import JsonExcel from "vue-json-excel";
import Pagination from "../components/Pagination.vue";
import ProductCategories from "../components/Products/ProductCategories.vue";
import ProductsHeader from "../components/Products/ProductsHeader.vue";
import ProductsTable from "../components/Products/ProductsTable.vue";
import ProductUnits from "../components/Products/ProductUnits.vue";
import AddProducts from "../components/Products/AddProducts.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "settingsProducts",
  components: {
    Pagination,
    Modal,
    JsonExcel,
    ProductCategories,
    Select2,
    ProductsHeader,
    ProductsTable,
    ProductUnits,
    AddProducts,
  },

  created() {
    if (
      !(
        this.hasPermission("Product_View") ||
        this.hasPermission("Product_Category_View") ||
        this.hasPermission("Product_Unit_View")
      )
    ) {
      this.$router.push("/restricted");
    }
  },

  updated() {
    if (this.$route.params.id && this.Products) {
      const product = this.Products.find(
        (prod) => prod.id === this.$route.params.id
      );
      if (product) {
        this.viewEdit(product);
      }
    }
  },

  watch: {
    "createProduct.type": function (newType, oldType) {
      if (newType == "Infinite") {
        this.createProduct.quantity = 0;
      }
    },
    "updateProduct.type": function (newType, oldType) {
      if (newType == "Infinite") {
        this.updateProduct.quantity = 0;
      }
    },
  },
  mounted() {
    this.getCategories();
    this.getProducts();
  },
  data() {
    return {
      isSearching: false,
      results: [],
      allResult: [],
      currItem: {
        data: {},
        index: null,
      },
      product_code: "",
      addedProducts: [],
      allProducts: [],
      exportAllLoading: false,
      errorMessage: {
        status: false,
        message: "",
      },
      filter: {
        status: "0",
        categoryId: "0",
        qry: "",
      },
      activeTab: "",
      isBusy: false,
      isBusyModal: false,
      createProduct: {
        code: null,
        name: null,
        description: null,
        unit: null,
        volume: null,
        group: null,
        groupSize: null,
        quantity: 99999999,
        type: "Finite",
        retailPrice: null,
        distributorPrice: null,
        availability: null,
        active: null,
        categoryId: null,
        restockLevel: 0,
        allowPriceOverride: null,
      },
      updateProduct: {
        code: null,
        name: null,
        description: null,
        unit: null,
        volume: null,
        group: null,
        groupSize: null,
        quantity: 99999999,
        type: "Finite",
        retailPrice: null,
        distributorPrice: null,
        active: null,
        categoryId: null,
        id: null,
        restockLevel: 0,
        allowPriceOverride: null,
        availability: null,
        minimumOrderQuantity: null,
        incrementalQuantity: null,
      },
      editProduct: {
        code: null,
        name: null,
        description: null,
        unit: null,
        volume: null,
        group: null,
        groupSize: null,
        quantity: 99999999,
        type: "Finite",
        retailPrice: null,
        distributorPrice: null,
        minimumOrderQuantity: null,
        incrementalQuantity: null,

        active: null,
        categoryId: null,
        id: null,
        restockLevel: 0,
        allowPriceOverride: null,
        availability: null,
      },
      v1: {
        code: false,
        name: false,
        unit: false,
        group: false,
        groupSize: false,
        quantity: false,
        type: false,
        retailPrice: false,
        distributorPrice: false,
        categoryId: false,
        restockLevel: false,
        availability: false,
        minimumOrderQuantity: false,
        incrementalQuantity: false,
      },
      v2: {
        code: false,
        name: false,
        unit: false,
        group: false,
        groupSize: false,
        quantity: false,
        type: false,
        retailPrice: false,
        distributorPrice: false,
        categoryId: false,
        restockLevel: false,
        availability: false,
        minimumOrderQuantity: false,
        incrementalQuantity: false,
      },
      isProductValid: null,
      Products: [],
      Product_fields: {
        "Product Code": "code",
        "Product Name": "name",
        "Product Category": "category.name",
        "Product Unit": "unit",
        "Minimum Order Quantity": "minimumOrderQuantity",
        "Incremental Quantity": "incrementalQuantity",
        "Plant Code": "sapPlantCode",
        "Tax Classification": "sapTaxClassification",
        "Status": "active",
        "Last Updated Date/Time": "updated"
      },
      types: [],
      categories: [],

      units: [],
      count: 0,
      page: 1,

      pageSize: 10,
      pageCount: 0,
      count: 0,

      pageSize: 10,

      hasNext: false,
      hasPrev: false,
      loading: true,
      modal: {
        isLoading: false,
        actionMethod: "",
        actionText: "",
        message: "",
      },
      images: null,
      previewUrl: "",
      dowloading: false,
    };
  },

  computed: {
    formattedProductFields() {
      const fields = { ...this.Product_fields }
      fields["Status"] = {
        field: "active",
        callback: (value) => {
          return value === true ? "Active" : "Inactive"
        }
      }
      fields["Last Updated Date/Time"] = {
        field: "updated",
        callback: (value) => {
          return value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : ''
        }
      }
      return fields
    },
    canAddProduct() {
      let proWithoutCat = this.addedProducts.filter(
        (v) => v.categoryId == null || !v.categoryId
      );
      if (proWithoutCat.length == 0) {
        return true;
      }
      return false;
    },
    user: function () {
      return this.$store.state.currentUser;
    },

    filteredCategory: function () {
      return this.categories.filter((x) => x.active);
    },
    mappedResults() {
      return [];
    },
  },
  methods: {
    updateProductCategory({ index, categoryId }) {
      this.addedProducts[index]["categoryId"] = categoryId;
    },
    resetErrMsg() {
      this.errorMessage.status = false;
    },
    removeItem(index) {
      this.addedDistributors.splice(index, 1);
    },
    AddProductToList() {
      $("#mod-confirm").modal("hide");
      let tempDist =
        this.Products.find((v) => v.code === this.currItem.data.productCode) ||
        {};
      if (tempDist.id) {
        this.errorMessage.status = true;
        this.errorMessage.message = "Products has already being Added!";
        this.results = [];
        return;
      }
      this.addedProducts.push(this.currItem.data);
      this.results.splice(this.currItem.index, 1);
    },
    ShowConfirmAddModal(i, index) {
      $("#mod-confirm").modal("show");

      this.currItem.data = i;
      this.currItem.index = index;
    },
    async SearchProduct(product_code) {
      this.errorMessage.status = false;
      this.isSearching = true;
      try {
        const res = await this.$http.get(
          `/Products/searchSapProduct?productCode=${product_code}`
        );
        const data = await res.json();
        this.results.push(data);
        this.isSearching = false;
      } catch (error) {
        let message = error.message ? error.message : null;
        this.errorMessage.status = true;
        this.isSearching = false;
        let msgArray = error.body.errors
          ? error.body.errors
          : error.data.errors
            ? error.data.errors
            : [];
        let msg = msgArray.length > 0 ? msgArray[0].slice(0, 18) : null;

        this.errorMessage.message =
          msg == "Could not retrieve"
            ? "No product Found"
            : message == "Already Added"
              ? "Product aleady Added!"
              : "Error Getting product Info";
      }
    },
    async addProducts() {
      this.isBusy = true;
      try {
        let res = null;
        let body = {};
        if (this.addedProducts.length > 0) {
          body = this.addedProducts.map((v) => ({
            product_Code: v.productCode,
            active: true,
            product_Plant: v.productPlant,
            categoryId: v.categoryId,
          }));
          let dForm = { products: body };
          res = await this.$http.post(
            "/Products/registerSapProductBulk",
            dForm
          );
          this.isBusy = false;
        }
        const results = await res.json();
        this.allProducts = results;
        this.addedProducts = [];
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        console.log(error);
        this.errorMessage =
          error.response.data.message ||
          "Failed to add products. Please try again.";
      }
    },
    refreshProduct() {
      this.getProducts();
    },
    switchTab(tab) {
      this.activeTab = tab;
    },
    openCreateModal() {
      $("#mod-add-product").modal("show");
    },
    closeCreateModal() {
      this.allProducts = [];
      $("#mod-add-product").modal("hide");
      this.addedProducts = [];
      this.refreshProduct();
      this.results = [];
    },
    onPickFile() {
      this.$refs.file.click();
    },
    cancelUpload() {
      this.previewUrl = "";
      this.images = null;
    },
    uploadFile() {
      this.images = this.$refs.file.files[0];
      this.previewUrl = URL.createObjectURL(this.images);
    },
    openModal(btnText, message) {
      this.modal.actionText = btnText;
      this.modal.message = message;
      $("#modal").modal("show");
    },

    closeModal() {
      this.modal.actionText = "";
      this.modal.message = "";
      $("#modal").modal("hide");
    },

    async validateProductCode(code) {
      this.isBusy = true;
      try {
        const response = await this.$http.get(
          `/Products/isProductCodeExist/${code}`
        );
        if (response.ok) {
          this.isBusy = false;
          this.isProductValid = response.data;
          return;
        }
      } catch (err) {
        this.$toast.info(err, {
          icon: true,
          rtl: false,
        });
      }
    },

    async downloadFile() {
      let parentID = this.user.parent.id;
      this.dowloading = true;
      await this.$http
        .get("/Products/getAllForManufacturer", {
          params: {
            parentId: parentID
          }
        })
        .then(function (res) {
          this.dowloading = false;
          this.products = res.body;
        })
        .catch(function (err) {
          console.log("Error downloading file", err);
        });
      this.dowloading = false;
      // $("#mod-download").modal("hide");
      return this.products;
    },

    openConfirmDownload() {
      $("#mod-download").modal("show");
    },

    reset() {
      this.filter = {
        status: "0",
        categoryId: "0",
        qry: "",
      };
      this.getProducts();
    },

    cancel() {
      const currentProduct = this.Products.find(
        (p) => p.id === this.editProduct.id
      );
      currentProduct.name = this.editProduct.name;
      currentProduct.code = this.editProduct.code;
      currentProduct.retailPrice = this.editProduct.retailPrice;
      currentProduct.distributorPrice = this.editProduct.distributorPrice;
      currentProduct.unit = this.editProduct.unit;
      currentProduct.active = this.editProduct.active;
      currentProduct.categoryId = this.editProduct.categoryId;
      currentProduct.allowPriceOverride = this.editProduct.allowPriceOverride;
      currentProduct.quantity = this.editProduct.quantity;
      $("#mod-edit").modal("hide");
    },

    viewExport() {
      //   $("#mod-export").modal("show");
    },

    viewAdd() {
      this.createProduct = {
        code: null,
        name: null,
        description: null,
        unit: null,
        volume: null,
        group: null,
        groupSize: null,
        quantity: 99999999,
        type: "Finite",
        retailPrice: null,
        distributorPrice: null,
        active: false,
        categoryId: null,
        restockLevel: 0,
        allowPriceOverride: false,
      };
      this.v1 = {
        code: false,
        name: false,
        unit: false,
        group: false,
        groupSize: false,
        quantity: false,
        type: false,
        categoryId: false,
        restockLevel: 0,
      };
      $("#mod-add-product").modal("show");
    },

    viewEdit(c) {
      var editValue = {
        code: c.code,
        name: c.name,
        description: c.description,
        quantity: c.quantity,
        type: c.type,
        retailPrice: c.retailPrice,
        distributorPrice: c.distributorPrice,
        unit: c.unit,
        categoryId: c.category.id,
        active: c.active,
        restockLevel: c.restockLevel,
        allowPriceOverride: c.allowPriceOverride,
        id: c.id,
        availability: c.saleStatus,
        minimumOrderQuantity: c.minimumOrderQuantity,
        incrementalQuantity: c.incrementalQuantity,
      };
      this.editProduct = editValue;
      this.previewUrl = c.imageUrl;
      this.updateProduct = c;
      this.updateProduct.availability = c.saleStatus;
      $("#mod-edit").modal("show");
    },

    viewFilter() {
      this.page = 1;
      $("#mod-filter").modal("show");
    },

    async create() {
      this.isBusyModal = true;
      this.isBusy = true;
      const formData = new FormData();
      formData.append("code", this.createProduct.code);
      formData.append("name", this.createProduct.name);
      formData.append("description", this.createProduct.description);
      formData.append("unit", this.createProduct.unit);
      formData.append("volume", "N/A");
      formData.append("group", "N/A");
      formData.append("groupSize", 0);
      formData.append("quantity", 9999999);
      formData.append("type", "Finite");
      formData.append("categoryId", this.createProduct.categoryId);
      formData.append("distributorPrice", this.createProduct.distributorPrice);
      formData.append("retailPrice", this.createProduct.retailPrice);
      formData.append("active", this.createProduct.active);
      formData.append("parentId", this.user.parentId);
      formData.append("restockLevel", this.createProduct.restockLevel);
      formData.append("SaleStatus", this.createProduct.availability);
      formData.append(
        "allowPriceOverride",
        this.createProduct.allowPriceOverride
      );
      formData.append("image", this.images);

      if (this.validateCreate()) {
        await this.$http
          .post("/Products/createForManufacturer", formData)
          .then(function (res) {
            this.isBusyModal = false;
            this.$toast.success("Product created successfully.", {
              icon: true,
              rtl: false,
            });
            this.isBusy = false;
            (this.previewUrl = ""), (this.isBusyModal = false);
            $("#mod-add-product").modal("hide");
            this.getProducts();
          })
          .catch(function () {
            this.isBusy = false;
            this.isBusyModal = false;
            (this.previewUrl = ""), $("#mod-add-product").modal("hide");
          });
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },

    validateCreate() {
      this.v1 = {
        code: false,
        name: false,
        unit: false,
        quantity: false,
        type: false,
        categoryId: false,
        restockLevel: false,
      };
      var isValid = true;

      if (!this.createProduct.code) {
        this.v1.code = true;
        isValid = false;
      }

      if (!this.createProduct.name) {
        this.v1.name = true;
        isValid = false;
      }

      if (!this.createProduct.unit) {
        this.v1.unit = true;
        isValid = false;
      }

      if (!this.createProduct.categoryId) {
        this.v1.categoryId = true;
        isValid = false;
      }

      if (Number(this.createProduct.retailPrice) <= 0) {
        this.v1.retailPrice = true;
        isValid = false;
      }

      if (Number(this.createProduct.distributorPrice) <= 0) {
        this.v1.distributorPrice = true;
        isValid = false;
      }

      if (Number(this.createProduct.restockLevel) < 0) {
        this.v1.restockLevel = true;
        isValid = false;
      }

      return isValid;
    },

    async update() {
      this.isBusyModal = true;
      this.isBusy = true;
      const formData = new FormData();
      formData.append("code", this.updateProduct.code);
      formData.append("name", this.updateProduct.name);
      formData.append("description", this.updateProduct.description);
      formData.append("unit", this.updateProduct.unit);
      formData.append("volume", this.updateProduct.volume);
      formData.append("group", this.updateProduct.group);
      formData.append("groupSize", this.updateProduct.group);
      formData.append("quantity", 9999999);
      formData.append("type", "Finite");
      formData.append("categoryId", this.updateProduct.categoryId);
      formData.append("distributorPrice", 1);
      formData.append("retailPrice", 1);
      formData.append("active", this.updateProduct.active);
      formData.append("id", this.updateProduct.id);
      formData.append("restockLevel", this.updateProduct.restockLevel);
      formData.append("SaleStatus", true);
      formData.append("allowPriceOverride", true);
      formData.append("image", this.images);
      formData.append(
        "minimumOrderQuantity",
        this.updateProduct.minimumOrderQuantity
      );
      formData.append(
        "incrementalQuantity",
        this.updateProduct.incrementalQuantity
      );

      if (this.validateUpdate()) {
        await this.$http
          .put(
            "/Products/updateForManufacturer/" + this.updateProduct.id,
            formData
          )
          .then(function (res) {
            this.isBusyModal = false;
            // if (this.$route.params.id) this.$router.push("/products");
            this.$toast.success("Update successful", {
              icon: false,
              rtl: false,
            });
            this.isBusy = false;
            this.isBusyModal = false;
            $("#mod-edit").modal("hide");
            (this.previewUrl = ""), this.getProducts();
          })
          .catch(function () {
            this.isBusy = false;
            this.isBusyModal = false;
            (this.previewUrl = ""), this.getProducts();
          });
      }
    },
    validateUpdate() {
      this.v2 = {
        code: false,
        name: false,
        unit: false,
        // group: false,
        // groupSize: false,
        quantity: false,
        type: false,
        categoryId: false,
        restockLevel: false,
      };
      var isValid = true;

      if (!this.updateProduct.code) {
        this.v2.code = true;
        isValid = false;
      }

      if (!this.updateProduct.name) {
        this.v2.name = true;
        isValid = false;
      }

      if (!this.updateProduct.unit) {
        this.v2.unit = true;
        isValid = false;
      }

      if (!this.updateProduct.categoryId) {
        this.v2.categoryId = true;
        isValid = false;
      }

      // if (Number(this.updateProduct.retailPrice) <= 0) {
      //   this.v2.retailPrice = true;
      //   isValid = false;
      // }

      // if (Number(this.updateProduct.distributorPrice) <= 0) {
      //   this.v2.distributorPrice = true;
      //   isValid = false;
      // }

      // if (Number(this.updateProduct.restockLevel) < 0) {
      //   this.v2.restockLevel = true;
      //   isValid = false;
      // }

      return isValid;
    },

    async getProducts() {
      this.Products = [];
      this.isBusy = true;
      this.loading = true;
      await this.$http
        .get(
          "/Products/getListForManufacturer?page=" +
          (this.page - 1) +
          "&pageSize=" +
          this.pageSize +
          (this.filter.status != "0" ? "&active=" + this.filter.status : "") +
          (this.filter.categoryId != "0"
            ? "&categoryId=" + this.filter.categoryId
            : "") +
          (this.filter.qry != "" ? "&query=" + this.filter.qry : "") +
          (this.user.parentId ? "&parentId=" + this.user.parentId : "")
        )
        .then(function (res) {
          this.Products = res.body.data;
          this.page = res.body.page + 1;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.isBusy = false;
          this.previewUrl = "";
          this.loading = false;
        })
        .catch(function () {
          this.loading = false;
        });

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },

    getTypes() {
      this.types = ["Finite", "Infinite"];
    },

    getCategories() {
      var t = "Product Category";

      this.$http
        .get(
          "/Categories/getListNoPagging?type=" +
          t +
          (this.user.parentId
            ? "&parentId=" + this.user.parentId
            : "Product Category")
        )
        .then(function (res) {
          this.categories = res.body;
        })
        .catch(function () { });
    },

    getUnits() {
      var t = "Product Unit";
      var a = true;

      this.$http
        .get(
          "/Categories/getListNoPagging?type=" +
          t +
          "&active=" +
          a +
          (this.user.parentId
            ? "&parentId=" + this.user.parentId
            : "Product Category")
        )
        .then(function (res) {
          this.units = res.body;
        })
        .catch(function () { });
    },

    formatDate(date) {
      return moment(date).format("lll");
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    formatNumber(val) {
      return helper.formatNumber(val);
    },

    prev() {
      this.page -= 1;
      this.getProducts();
    },
    next() {
      this.page += 1;
      this.getProducts();
    },

    gotoPage(page) {
      this.page = page;
      this.getProducts();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getProducts();
    },

    viewUploadProducts() {
      this.$router.push("/manufacturer-products-upload");
    },

    viewUploadPrice() {
      this.$router.push("/manufacturer-price-upload");
    },
  },
}
</script>
